const formatosArchivo =
  'image/jpeg,image/heif,image/heic,image/png, application/pdf';

const validarComprobantes = (comprobantesList) => {
  return !!(comprobantesList && comprobantesList.length > 0);
};

export { formatosArchivo, validarComprobantes };
